module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-600.3e8ff770.woff";